import _ from 'underscore';
import PerformanceMetricsColumns from '../common-columns/performance-metrics-columns';
import getLevel from '../util/get-level';

export function getName({
  AdExtensionType,
  AssociationType,
  CampaignId,
  AdGroupId,
}) {
  return `${AdExtensionType}${getLevel({
    CampaignId,
    AdGroupId,
  })}${AssociationType}`;
}

export function getColumnsMetadata() {
  return _.defaults({
    CampaignName: 'Campaign/Name',
    AdGroupName: 'AdGroup/Name',
    Delivery: 'AdExtension/Delivery',
    Status: 'AdExtension/Status',
    AdExtensionId: 'AdExtension/Id',
    StartDate: 'AdExtension/Scheduling/StartDate',
    EndDate: 'AdExtension/Scheduling/EndDate',
    Schedule: 'AdExtension/Scheduling/DayTimeRanges',
    TimeZone: 'AdExtension/Scheduling/UseSearcherTimeZone',
  }, PerformanceMetricsColumns);
}

export function getRoute({
  AdExtensionType,
  AssociationType,
  CampaignId,
  AdGroupId,
}) {
  const level = getLevel({
    CampaignId,
    AdGroupId,
  });

  const typeFragment = AdExtensionType
    .substr(0, AdExtensionType.length - 'AdExtension'.length)
    .toLowerCase();
  const associationFragment = AssociationType.toLowerCase();

  switch (level) {
    case 'AdGroup':
      return `customer/:customer_id/account/:account_id/campaign/:campaign_id/adgroup/:adgroup_id/adextension/${typeFragment}/association/${associationFragment}`;
    case 'Campaign':
      return `customer/:customer_id/account/:account_id/campaign/:campaign_id/adextension/${typeFragment}/association/${associationFragment}`;
    case 'Account':
    default:
      return `customer/:customer_id/account/:account_id/adextension/${typeFragment}/association/${associationFragment}`;
  }
}


export function getRouteForNewUI({
  getUrlSearch,
  selection: {
    AdExtensionType,
    AssociationType,
    CampaignId,
    AdGroupId,
  },
}) {
  const search = getUrlSearch({
    campaignId: CampaignId,
    adGroupId: AdGroupId,
  });

  const typeFragment = AdExtensionType
    .substr(0, AdExtensionType.length - 'AdExtension'.length)
    .toLowerCase();
  const type = _.result({
    sitelink2: 'sitelink',
  }, typeFragment, typeFragment);

  const associationFragment = AssociationType.toLowerCase();

  return `extensions/${type}/association/${associationFragment}${search}`;
}
